import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeOtherOPCategoryListItem extends SearchModelBase {
    type: string = '';
    description: string = '';
    prefix: string = '';
    no: string = '';
    cid: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Category', width: 100, dataIndex: 'type', defaultColumnFocus : true}),
        XCol.Create({ col: 1, text: 'Description', width: 300, dataIndex: 'description'}),
        XCol.Create({ col: 2, text: 'Ref # Prefix', width: 100, dataIndex: 'prefix'}),
        XCol.Create({ col: 3, text: 'Next #', width: 100, dataIndex: 'no'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeOtherOPCategoryListItem.prototype.type, orderByAscending: true };

    public static formatData(data: CodeOtherOPCategoryListItem[]) {
        return data.map((d: CodeOtherOPCategoryListItem) => ({
          ...d,
        }));
    }

}
